import { render, staticRenderFns } from "./AppAsideMenu.vue?vue&type=template&id=81db3930&scoped=true&"
import script from "./AppAsideMenu.vue?vue&type=script&lang=js&"
export * from "./AppAsideMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppAsideMenu.vue?vue&type=style&index=0&id=81db3930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81db3930",
  null
  
)

export default component.exports